export const MAP_ZOOM_LEVELS = [1, 2, 4, 6] as const;
export const MIN_MAP_ZOOM = MAP_ZOOM_LEVELS[0];
export const MAX_MAP_ZOOM = MAP_ZOOM_LEVELS[MAP_ZOOM_LEVELS.length - 1];

export function clampMapZoom(value: number): number {
  return Math.min(MAX_MAP_ZOOM, Math.max(MIN_MAP_ZOOM, value));
}

export function zoomFromPinch(startZoom: number, startDistance: number, currentDistance: number): number {
  if (startDistance <= 0 || currentDistance <= 0) return clampMapZoom(startZoom);
  return Math.round(clampMapZoom(startZoom * currentDistance / startDistance) * 20) / 20;
}

export function steppedMapZoom(zoom: number, direction: "in" | "out"): number {
  if (direction === "in") {
    return MAP_ZOOM_LEVELS.find((level) => level > zoom + 0.01) ?? MAX_MAP_ZOOM;
  }
  return [...MAP_ZOOM_LEVELS].reverse().find((level) => level < zoom - 0.01) ?? MIN_MAP_ZOOM;
}

export function anchoredScrollPosition(contentPoint: number, viewportPoint: number, zoom: number): number {
  return Math.max(0, contentPoint * zoom - viewportPoint);
}

export function oppositePaintAction(action: "add" | "remove"): "add" | "remove" {
  return action === "add" ? "remove" : "add";
}

export function paintActionChangesSelection(action: "add" | "remove", isSelected: boolean): boolean {
  return action === "add" ? !isSelected : isSelected;
}

export function createTouchPaintRollback(changes: ReadonlyMap<string, "add" | "remove">, selectedId: string | null) {
  return {
    selectedId,
    changes: [...changes].map(([id, action]) => ({ id, action: oppositePaintAction(action) })),
  };
}
